import { useUpdateGoal } from 'features/goals';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';
import { v4 as uuidv4 } from 'uuid';

import { useGoalById } from './use-goal-by-id';

export const useCreateSection = (goalId?: ID) => {
  const goal = useGoalById(goalId);
  const { submit: updateGoal } = useUpdateGoal();

  return useCallback(() => {
    if (!goal?.id) {
      return;
    }

    const sections = goal.sections ?? [];

    updateGoal({
      id: goal.id,
      sections: [
        ...sections,
        {
          id: uuidv4(),
          name: '',
          tasks: [],
          createdAt: new Date(),
        },
      ],
    });
  }, [goal?.id, goal?.sections, updateGoal]);
};
